import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <h3>SimpliConnect</h3>
      <p>© 2026 SimpliConnect. All rights reserved.</p>
      <p>Email: info@simpliconnects.com</p>
      <p>Phone: +94 77 225 5980</p>
    </footer>
  );
}

export default Footer;